import type { RouteObject } from 'react-router-dom';

import { AuthLayout } from '@/components/layout/auth-layout';
import { routes } from '@/config/routes';

import { RedirectIfAuthenticated } from './guards/redirect-if-authenticated';
import { RequireFlowState } from './guards/require-flow-state';
import { lazyRoute } from './lazy-route';

export const publicRoutes: RouteObject[] = [
  {
    element: <RedirectIfAuthenticated />,
    children: [
      {
        element: <AuthLayout />,
        children: [
          {
            path: routes.login,
            lazy: lazyRoute(() => import('@/pages/auth/login.page'), 'LoginPage'),
          },
          {
            element: <RequireFlowState stateKey="phone" fallback={routes.login} />,
            children: [
              {
                path: routes.loginVerifyOtp,
                lazy: lazyRoute(() => import('@/pages/auth/login-otp.page'), 'LoginOtpPage'),
              },
            ],
          },
          {
            path: routes.forgotPassword,
            lazy: lazyRoute(
              () => import('@/pages/auth/forgot-password.page'),
              'ForgotPasswordPage',
            ),
          },
          {
            element: <RequireFlowState stateKey="phone" fallback={routes.forgotPassword} />,
            children: [
              {
                path: routes.forgotVerify,
                lazy: lazyRoute(() => import('@/pages/auth/forgot-otp.page'), 'ForgotOtpPage'),
              },
            ],
          },
          {
            path: routes.forgotReset,
            lazy: lazyRoute(() => import('@/pages/auth/reset-password.page'), 'ResetPasswordPage'),
          },
          // Unguarded at the route level, like forgotReset above: RequireFlowState keys off
          // location state and this step has none, so the page guards itself off the in-memory
          // activation token.
          {
            path: routes.loginSetPassword,
            lazy: lazyRoute(() => import('@/pages/auth/set-password.page'), 'SetPasswordPage'),
          },
        ],
      },
    ],
  },
];
